const { NODE_ENV } = require("../../env");
const apiBase = require("../api-base");
/**
 * cj-web 服务端、客户端通用配置
 */
const apiConfig = {
  // 开发
  development: require("./development"),
  ptest: require("./ptest"),
  //测试
  test: require("./test"),
  testnew: require("./testnew"),
  /** 线上环境 */
  production: require("./production"),
  /** 线上环境-国内代理 */
  "production-cn": require("./production-cn"),
};

const getOSEnv = (key) => {
  if (typeof process === "undefined") return;
  return process.env[key];
};

// 线上node服务端 api服务配置，正是环境通过系统环境变量设置
const apiNodeConfig = {
  "cj-platform-web":
    getOSEnv("cjPlatformWeb") || "http://cj-platform-web-svc.cj-platform-center:9991/", // 这个域名运维容器内部实现还是走的美国服务后台, 因为对应的后台没有杭州服务
  app: getOSEnv("app") || "http://app/",
  cj: getOSEnv("cj") || "http://cucheng-app-web.cj.com/",
  "elastic-api":
    getOSEnv("elasticApi") || "http://cj-elastic-search-rest-api.cj-product-center:8070/",
  "website-api":
    getOSEnv("websiteApi") || "http://cj-elastic-search-website-api.cj-product-center:8070/",
  "website-vip-api": getOSEnv("websiteVipApi") || "http://cj-elastic-search-website-vip-api.cj-product-center:8070/",
  "website-api-home": getOSEnv("websiteApiHome") || "http://cj-elastic-search-website-api-home.cj-product-center:8070/",

  warehouseBuildWeb:
    getOSEnv("warehouseBuildWeb") ||
    "http://172.16.102.105:8001/",
  "product-api":
    getOSEnv("productApi") ||
    "http://cj-product-center-rest-api-feign.cj-product-center:8079/",
  "chat-web": getOSEnv("chatWeb") || "http://chat-web.chat-center:8883/",
  statistics: getOSEnv("statistics") || "http://cj-about.cj-center:8099/",
  operationCenterApi:
    getOSEnv("operationCenterApi") ||
    "http://cj-operation-center-rest-api.cj-operation-center:9086/",
  productSku: getOSEnv("productSku") || "https://cache.cjdropshipping.com/",
  // getOSEnv暂时使用和上面一样的，k8s少配置一次
  productDetail: getOSEnv("productSku") || "https://cache.cjdropshipping.com/",
  "affiliate-center-web":
    getOSEnv("AffiliateWenterWeb") ||
    "http://affiliate-center-web.affiliate-center:8095/",
  "userCenterForeignWeb": getOSEnv("userCenterForeignWeb") || "http://cujia-user-center-foreign-web.cj-user-center:9078/",
  "payment-center-web": getOSEnv("paymentCenterWeb") || "http://other-cj-payment-web.cj-payment-center:8071/",
};

if (NODE_ENV === "development" || NODE_ENV === "test") {
  // node开发环境直连
  Object.keys(apiNodeConfig).forEach((key) => {
    apiNodeConfig[key] = apiBase;
  });
  apiNodeConfig.productSku = "https://offline-pre-oss.cjdropshipping.cn/"
  apiNodeConfig.productDetail = "https://offline-pre-oss.cjdropshipping.cn/"
} 
module.exports = {
  api: apiConfig,
  apiNode: apiNodeConfig,
  // 默认币种
  currency: { symbol: "$", currency: "USD", NAME: "美元", rate: "1" },
  // 人工翻译的语种
  languages: getOSEnv("languages") ? JSON.parse(getOSEnv("languages")) : ["zh", "en", "de", "fr", "id", "th","pt"],
  ossHost: {
    development: "https://test-frontend.cjdropshipping.com",
    test: getOSEnv("OSSHOST") || "https://test-cj-frontend.oss-cn-hangzhou.aliyuncs.com",
    testnew: getOSEnv("OSSHOST") || "https://test-cj-frontend.oss-cn-hangzhou.aliyuncs.com",
    "production-cn":
      getOSEnv("OSSHOST") || "https://cj-front-end.oss-cn-hangzhou.aliyuncs.com",
    production: getOSEnv("OSSHOST") || "https://sv-resource.oss-accelerate.aliyuncs.com",
  },
};
